<template>
  <div class="field-component">
    <div class="field-name">{{ title }}</div>
    <div class="sep-line">
      <div class="sep-bg-wrapper">
        <div class="sep-bg" style=""></div>
      </div>
      <div class="sep-label"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'orderLable',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.field-component{
  margin: 0 5px 10px 5px;
}
.field-name {
  font-size: 13px;
  color: rgb(19, 132, 255);
  word-wrap: break-word;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-weight: 600;
  line-height: 15px;
  padding: 5px 0;
  position: relative;
  word-break: break-word;
}

.sep-bg-wrapper {
  bottom: 0;
  left: 0;
  padding-left: 8px;
  position: absolute;
  right: 0;
}

.sep-line {
  height: 6px;
  position: relative;
}

.sep-bg {
  border-bottom: 1px solid;
  height: 0;
  opacity: .2;
  width: 100%;
  border-color: rgb(19, 132, 255);
}

.sep-label {
  height: 6px;
  border-radius: 0 6px;
  bottom: 0;
  left: 0;
  max-width: 81%;
  min-width: 8%;
  overflow: hidden;
  position: absolute;
  text-overflow: ellipsis;
  top: 0;
  white-space: nowrap;
  background-color: rgb(19, 132, 255);
}
</style>